import { ReactElement } from 'react';
import { MoreActionsIcon } from './MoreActionsIcon';
import { MoreActionsProps } from './MoreActionsProps';

export type MoreActionsElement = ReactElement<
  MoreActionsProps,
  typeof MoreActionsIcon
>;
